import AboutSriLanka from "./aboutSriLanka";

export default AboutSriLanka;